import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const CashWithColor = ({ size = 36, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect width={36} height={36} rx={18} fill="#fff" />
    <Path
      d="M27.405 26.136H8.595a1.463 1.463 0 0 1-1.463-1.463V14.521c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.152c0 .808-.655 1.463-1.463 1.463Z"
      fill="#6DB6FF"
    />
    <Path
      d="M27.405 25.04H8.595a1.463 1.463 0 0 1-1.463-1.462V13.425c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.152c0 .808-.655 1.464-1.463 1.464Z"
      fill="#AAD5FF"
    />
    <Path
      d="M27.405 23.945H8.595a1.463 1.463 0 0 1-1.463-1.463V12.329c0-.808.655-1.463 1.463-1.463h18.81c.808 0 1.463.655 1.463 1.463v10.153c0 .808-.655 1.463-1.463 1.463Z"
      fill="#2E85DD"
    />
    <Path
      d="M27.405 22.85H8.595a1.463 1.463 0 0 1-1.462-1.464V11.234c0-.809.655-1.464 1.463-1.464h18.81c.807 0 1.462.655 1.462 1.463v10.153c0 .808-.655 1.463-1.463 1.463Z"
      fill="#389CFF"
    />
    <Path
      d="M10.18 22.847H8.593a1.462 1.462 0 0 1-1.462-1.462V11.232c0-.806.656-1.462 1.462-1.462h1.585c-.806 0-1.462.656-1.462 1.462v10.153c0 .81.656 1.462 1.462 1.462Z"
      fill="#389CFF"
    />
    <Path
      d="M27.276 13.558v5.501a2.376 2.376 0 0 0-2.38 2.38H11.1a2.375 2.375 0 0 0-2.374-2.38v-5.501a2.373 2.373 0 0 0 2.374-2.374h13.796a2.375 2.375 0 0 0 2.38 2.374Z"
      fill="#AAD5FF"
    />
    <Path
      d="M11.205 16.974a.893.893 0 1 0 0-1.787.893.893 0 0 0 0 1.787ZM24.797 16.974a.893.893 0 1 0 0-1.787.893.893 0 0 0 0 1.787Z"
      fill="#6DB6FF"
    />
    <Path
      d="M18.01 20.383a4.115 4.115 0 1 0 0-8.23 4.115 4.115 0 0 0 0 8.23Z"
      fill="#fff"
    />
    <Path
      d="M18.65 14.381c.112.154.179.309.219.476.003.013.035.027.054.027.17.002.34.001.51.002.119 0 .151.032.152.149v.301c-.002.095-.04.132-.135.132h-.516c-.03 0-.051.002-.059.04-.104.542-.438.882-.947 1.062-.144.05-.296.077-.447.116.003.005.01.017.019.026.54.587 1.048 1.202 1.553 1.82.017.019.034.04.042.063.023.068-.032.14-.11.141-.226.002-.453 0-.68.001-.047 0-.077-.024-.106-.058-.434-.507-.868-1.014-1.305-1.52-.133-.153-.273-.3-.41-.449a.16.16 0 0 1-.048-.117c.002-.134 0-.268 0-.401.001-.096.041-.135.14-.136.162 0 .325.003.488-.003.229-.008.45-.048.653-.165a.671.671 0 0 0 .32-.395v-.024H16.59c-.122 0-.153-.03-.153-.152v-.296c0-.1.036-.135.136-.135H18c-.033-.048-.055-.085-.083-.117a.757.757 0 0 0-.5-.247c-.198-.023-.398-.023-.597-.031-.08-.003-.161 0-.241 0-.102-.001-.141-.04-.141-.14v-.41c0-.108.033-.142.14-.142h2.86c.106 0 .14.035.14.142v.302c0 .102-.035.138-.14.138H18.652Z"
      fill="#389CFF"
    />
  </Svg>
)

export default CashWithColor
